import { MapPin, Clock, Bus, MessageSquare } from "lucide-react";
import Reveal from "@/components/Reveal";
import { SMS_URL } from "@/config";

export default function Lieux() {
  return (
    <div data-testid="lieux-page">
      <section className="mx-auto max-w-7xl px-6 py-20 md:px-12 md:py-28">
        <Reveal>
          <p className="font-display text-xs tracking-[0.2em] uppercase text-taupe">Lieux de consultation</p>
          <h1 className="mt-6 max-w-3xl font-display text-4xl font-light leading-tight tracking-tight text-charcoal sm:text-5xl">
            Des espaces calmes pour se retrouver
          </h1>
          <p className="mt-8 max-w-prose text-base leading-relaxed text-stone-700">
            Les séances ont lieu dans des cadres apaisés, pensés pour que les jeunes se sentent en
            sécurité dès la première rencontre.
          </p>
        </Reveal>

        <div className="mt-16 grid gap-8 md:grid-cols-2">
          <Reveal>
            <img
              src="/cabinet.jpg"
              alt="Le cabinet principal : fauteuils accueillants et espace lumineux"
              data-testid="lieux-image"
              className="aspect-[3/4] w-full rounded-2xl object-cover"
            />
            <p className="mt-4 text-xs text-stone-500" data-testid="lieux-image-caption">
              Le Centre Kintsugi, à Liège
            </p>
          </Reveal>
          <div className="flex flex-col gap-8">
            {[
              {
                id: "cabinet-1",
                title: "Centre Kintsugi — Cabinet principal",
                details: [
                  { icon: MapPin, text: "Rue de Joie, 38-40 — 4000 Liège" },
                  { icon: null, text: "Gare des Guillemins à 10 minutes de marche" },
                  { icon: Bus, text: "Bus Tec — Lignes 20 (arrêt rue de Joie) et 21 (arrêt rue J. Makoy) à proximité" },
                ],
              },
              { id: "cabinet-2", title: "Second lieu de consultation", details: null },
            ].map((lieu, i) => (
              <Reveal key={lieu.id} delay={0.1 + i * 0.1}>
                <article
                  data-testid={`lieu-card-${lieu.id}`}
                  className={`rounded-2xl border bg-sand p-8 ${
                    lieu.details ? "border-stone-300" : "border-dashed border-stone-300"
                  }`}
                >
                  <h2 className="font-display text-xl text-charcoal">{lieu.title}</h2>
                  {lieu.details ? (
                    <div className="mt-4 flex flex-col gap-2">
                      {lieu.details.map((line) => (
                        <p key={line.text} className="flex items-center gap-2 text-sm text-stone-600">
                          {line.icon ? (
                            <line.icon size={16} className="shrink-0 text-taupe" />
                          ) : (
                            <span className="w-4 shrink-0" />
                          )}
                          {line.text}
                        </p>
                      ))}
                      <a
                        href={SMS_URL}
                        data-testid="lieux-agenda-button"
                        className="mt-2 inline-flex w-fit items-center gap-2 rounded-full bg-taupe px-5 py-2.5 font-display text-sm text-bone transition-colors hover:bg-taupe-dark"
                      >
                        <MessageSquare size={16} /> Prendre rendez-vous par SMS
                      </a>
                    </div>
                  ) : (
                    <>
                      <p className="mt-4 flex items-center gap-2 text-sm text-stone-500">
                        <MapPin size={16} className="shrink-0 text-taupe" /> Adresse à confirmer prochainement
                      </p>
                      <p className="mt-2 flex items-center gap-2 text-sm text-stone-500">
                        <Clock size={16} className="shrink-0 text-taupe" /> Horaires sur rendez-vous
                      </p>
                    </>
                  )}
                </article>
              </Reveal>
            ))}
            <Reveal delay={0.3}>
              <p className="text-sm leading-relaxed text-stone-500" data-testid="lieux-note">
                L'adresse du second lieu de consultation sera publiée ici très bientôt.
              </p>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
